module.exports = __webpack_public_path__ + "static/media/the_courage_to_be_disliked.0f2019cf.avif";